import { AlertTriangle, TrendingUp, X } from 'lucide-react'
import { FC } from 'react'
import { z } from 'zod/v4'
import ShowcaseCard from '../../components/Showcase/ShowcaseCard'
import ShowcaseHeader from '../../components/Showcase/ShowcaseHeader'
import ShowcaseStatItem from '../../components/Showcase/ShowcaseStatItem'

// Zod schema for package buy June 25 campaign data validation
export const PackageBuyJune25CampaignDataSchema = z.object({
	expiresTitle: z.string().default('Your access is Expiring'),
	statsTitle: z.string().default('Your Amazing Impact'),
	msgSentDesc: z.string().default('Average users send'),
	msgSent: z.string().default('252 messages/month'),
	timeSentDesc: z.string().default('Each saving'),
	timeSent: z.string().default('1.5 hours monthly'),
	lastItemDesc: z.string().default('Join 14,127+ users'),
	lastItem: z.string().default('achieving results'),
	whatYouLoseTitle: z.string().default("What you'll lose"),
	providerId: z.union([z.enum(['apple.com', 'google.com']), z.literal('').transform(() => 'google.com')]),
	email: z.string().transform(val => {
		if (val === '') return undefined
		if (val.endsWith('@privaterelay.appleid.com')) return undefined
		return val
	}),
	timestamp: z.number().optional(), // Unix timestamp for token expiration
})

export type PackageBuyJune25CampaignData = z.infer<typeof PackageBuyJune25CampaignDataSchema>

interface CampaignPackageBuyJune25ShowcaseProps {
	data: PackageBuyJune25CampaignData
}

const CampaignPackageBuyJune25Showcase: FC<CampaignPackageBuyJune25ShowcaseProps> = ({ data }) => (
	<div className="max-w-md w-full">
		<h2 className="text-4xl font-bold mb-8 text-left">Don&apos;t Lose Your Progress!</h2>
		<div className="space-y-8 mb-12">
			{/* Access expires warning */}
			<ShowcaseCard className="border-2 border-red-300/20 bg-red-200/20">
				<ShowcaseHeader icon={<AlertTriangle size={24} className="text-red-500" />} title={data.expiresTitle} />
				<p className="text-lg opacity-90">Don&apos;t lose your messaging progress</p>
			</ShowcaseCard>

			{/* Impact stats */}
			<ShowcaseCard>
				<ShowcaseHeader
					icon={<TrendingUp size={24} className="text-hitemup-green" />}
					title={data.statsTitle}
				/>
				<div className="space-y-4">
					<ShowcaseStatItem label={data.msgSentDesc} value={data.msgSent} />
					<ShowcaseStatItem label={data.timeSentDesc} value={data.timeSent} />
					{data.lastItemDesc && data.lastItem && (
						<ShowcaseStatItem label={data.lastItemDesc} value={data.lastItem} />
					)}
				</div>
			</ShowcaseCard>

			{/* What you'll lose */}
			<ShowcaseCard className="border-2 border-red-300/20 bg-red-200/20 ">
				<ShowcaseHeader title={data.whatYouLoseTitle} />
				<div className="space-y-3">
					{[
						'Access to Send to Your Groups',
						'SmartWrite AI',
						'Scheduled messages',
						'CSV imports',
						'Unlimited tags',
					].map((feature, index) => (
						<div key={index} className="flex items-center gap-3">
							<X size={20} className="text-red-300 shrink-0" />
							<span className="text-lg opacity-90">{feature}</span>
						</div>
					))}
				</div>
			</ShowcaseCard>
		</div>
		<div className="text-center">
			<p className="text-lg font-semibold mb-4">Upgrade now to keep your momentum going!</p>
		</div>
	</div>
)

export default CampaignPackageBuyJune25Showcase
